import { patchCompany } from "../../cs_edit";

export function initCustomersRenewInlineEdit() {
  $(".customers-table .company-renews")
    .off("click.cs-inline-edit-renews")
    .on("click.cs-inline-edit-renews", function (e) {
      e.stopPropagation();
      if ($(this).find(".inline-edit-input").length) return;

      const currentValue = ($(this).attr("data-sort-value") || "").trim();
      const id = $(this).closest(".customer-row").attr("data-id");
      const csDatumId = $(this)
        .closest(".customer-row")
        .attr("data-cs-datum-id");
      if (!id) return;

      const originalHTML = $(this).html();
      const input = document.createElement("input");
      input.type = "date";
      input.className = "inline-edit-input";
      input.value = currentValue;

      $(this).text("");
      $(this).append(input);
      input.focus();

      let saved = false;
      const cell = this as HTMLElement;

      const save = () => {
        if (saved) return;
        saved = true;

        const newValue = input.value;
        if (newValue === currentValue) {
          cancel();
          return;
        }

        $(cell).text("Saving...");
        $(cell).addClass("inline-edit-saving");

        const csDatumAttributes: { [key: string]: string } = {};
        csDatumAttributes.renews = newValue;

        if (csDatumId) {
          csDatumAttributes.id = csDatumId;
        }

        patchCompany(
          id,
          { cs_datum_attributes: csDatumAttributes },
          cell,
          originalHTML,
        );
      };

      const cancel = () => {
        if (saved) return;
        saved = true;
        $(cell).html(originalHTML);
      };

      input.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          save();
        } else if (event.key === "Escape") {
          event.preventDefault();
          cancel();
        }
      });

      input.onchange = save;
      input.onblur = cancel;
    });
}
